/* GDB cart drawer + product page behaviour, 13 Sep 2026. Loaded (defer) from snippets/cart-drawer.liquid.
   Depends on Dawn globals: routes, fetchConfig, subscribe, PUB_SUB_EVENTS. */
(() => {
  if (window.gdbCartLoaded) return;
  window.gdbCartLoaded = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const source = doc.querySelector('.drawer__inner');
      const target = document.querySelector('#CartDrawer .drawer__inner');
      if (source && target) target.innerHTML = source.innerHTML;
      const drawer = document.querySelector('cart-drawer');
      const freshDrawer = doc.querySelector('cart-drawer');
      if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const source = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && source) bubble.innerHTML = source.innerHTML;
    }
  }

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
  }

  async function postCart(url, payload) {
    const response = await fetch(url, {
      ...fetchConfig(),
      body: JSON.stringify({ ...payload, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    return response.json();
  }

  /* ---------- Discount code ---------- */
  class GdbCartDiscount extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.msg = this.querySelector('.gdb-discount__msg');
      this.list = this.querySelector('.gdb-discount__codes');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.apply();
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-remove]');
        if (button) this.remove(button.dataset.remove);
      });
      this.syncShippingCodes();
    }

    get codes() {
      return [...this.querySelectorAll('[data-code]')].map((el) => el.dataset.code);
    }

    setBusy(state) {
      this.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    showMessage(text, isError) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.classList.toggle('gdb-discount__msg--error', !!isError);
      this.msg.classList.toggle('gdb-discount__msg--ok', !isError);
      this.msg.hidden = !text;
    }

    addPill(code, shipping) {
      if (this.codes.some((c) => c.toLowerCase() === code.toLowerCase())) return;
      const li = document.createElement('li');
      li.className = 'gdb-discount__pill' + (shipping ? ' gdb-discount__pill--shipping' : '');
      li.dataset.code = code;
      const span = document.createElement('span');
      span.className = 'gdb-discount__pill-code';
      span.textContent = code;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gdb-discount__remove';
      button.dataset.remove = code;
      button.setAttribute('aria-label', (this.dataset.removeLabel || 'Remove __CODE__').replace('__CODE__', code));
      button.textContent = '×';
      li.append(span, button);
      this.list.append(li);
    }

    async syncShippingCodes() {
      try {
        const response = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        const known = this.codes.map((c) => c.toLowerCase());
        (cart.discount_codes || []).forEach((entry) => {
          if (entry.applicable && !known.includes(String(entry.code).toLowerCase())) this.addPill(entry.code, true);
        });
      } catch (error) {
        /* no-op: pills from Liquid are still correct */
      }
    }

    async apply() {
      const code = this.input.value.trim();
      if (!code) return;
      const existing = this.codes;
      if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) {
        this.input.value = '';
        this.showMessage(this.dataset.applied, false);
        return;
      }
      this.setBusy(true);
      try {
        const data = await postCart(routes.cart_update_url, { discount: [...existing, code].join(',') });
        const entry = (data.discount_codes || []).find((d) => String(d.code).toLowerCase() === code.toLowerCase());
        if (entry && entry.applicable === false) {
          await postCart(routes.cart_update_url, { discount: existing.join(',') });
          this.showMessage(this.dataset.invalid, true);
          this.input.select();
          return;
        }
        const pills = [...parse(data.sections['cart-drawer']).querySelectorAll('[data-code]')].map((el) =>
          el.dataset.code.toLowerCase()
        );
        const shippingOnly = !!entry && entry.applicable === true && !pills.includes(code.toLowerCase());
        renderSections(data.sections);
        checkGift(); // a code can take the cart under the gift threshold: re-check the mask
        const fresh = document.querySelector('gdb-cart-discount');
        if (fresh) {
          if (shippingOnly) fresh.addPill(entry.code || code, true);
          fresh.showMessage(shippingOnly ? fresh.dataset.shipping : fresh.dataset.applied, false);
        }
      } catch (error) {
        this.showMessage(this.dataset.invalid, true);
      } finally {
        this.setBusy(false);
      }
    }

    async remove(code) {
      const remaining = this.codes.filter((c) => c.toLowerCase() !== code.toLowerCase());
      this.setBusy(true);
      try {
        const data = await postCart(routes.cart_update_url, { discount: remaining.join(',') });
        renderSections(data.sections);
        checkGift();
      } catch (error) {
        this.showMessage(this.dataset.invalid, true);
      } finally {
        this.setBusy(false);
      }
    }
  }
  customElements.define('gdb-cart-discount', GdbCartDiscount);

  /* ---------- Pairs well with: one-tap add ---------- */
  class GdbCartPairs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gdb-add]');
        if (button) this.add(button);
      });
    }

    async add(button) {
      const id = Number(button.dataset.gdbAdd);
      if (!id) return;
      const label = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.adding || label;
      try {
        const data = await postCart(routes.cart_add_url, { items: [{ id, quantity: 1 }] });
        if (data.status) throw new Error(data.description || 'add failed');
        renderSections(data.sections);
        openDrawer();
      } catch (error) {
        button.disabled = false;
        button.textContent = label;
      }
    }
  }
  customElements.define('gdb-cart-pairs', GdbCartPairs);

  /* ---------- Dispatch countdown + delivery estimate ---------- */
  class GdbCartDispatch extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.gdb-dispatch__text');
      this.holidays = (this.dataset.holidays || '').split(',').filter(Boolean);
      this.render();
      this.timer = setInterval(() => this.render(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    parts(date) {
      const formatter = new Intl.DateTimeFormat('en-AU', {
        timeZone: this.dataset.timezone || 'Australia/Sydney',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      });
      const map = Object.fromEntries(formatter.formatToParts(date).map((p) => [p.type, p.value]));
      return {
        weekday: map.weekday,
        iso: `${map.year}-${map.month}-${map.day}`,
        hour: Number(map.hour) % 24,
        minute: Number(map.minute),
      };
    }

    isBusinessDay(date) {
      const p = this.parts(date);
      return p.weekday !== 'Sat' && p.weekday !== 'Sun' && !this.holidays.includes(p.iso);
    }

    addDays(date, n) {
      return new Date(date.getTime() + n * 86400000);
    }

    nextBusinessDay(date) {
      let next = this.addDays(date, 1);
      while (!this.isBusinessDay(next)) next = this.addDays(next, 1);
      return next;
    }

    addBusinessDays(date, n) {
      let result = date;
      for (let i = 0; i < n; i += 1) result = this.nextBusinessDay(result);
      return result;
    }

    fmtDay(date) {
      return new Intl.DateTimeFormat('en-AU', {
        timeZone: this.dataset.timezone || 'Australia/Sydney',
        weekday: 'short',
        day: 'numeric',
      })
        .format(date)
        .replace(',', '');
    }

    fmtMonth(date) {
      return new Intl.DateTimeFormat('en-AU', { timeZone: this.dataset.timezone || 'Australia/Sydney', month: 'short' }).format(date);
    }

    // The instant at which the Sydney clock reads <cutoff>:00 on the calendar day of `day` (DST-safe).
    cutoffInstant(day, cutoff) {
      const p = this.parts(day);
      let target = new Date(day.getTime() + ((cutoff - p.hour) * 60 - p.minute) * 60000);
      const check = this.parts(target);
      if (check.hour !== cutoff || check.minute !== 0) {
        target = new Date(target.getTime() + ((cutoff - check.hour) * 60 - check.minute) * 60000);
      }
      return target;
    }

    // Always a countdown to the NEXT real cutoff (today's if still ahead on a business day,
    // otherwise the next business day's), so weekends and evenings still tick.
    render(now = new Date()) {
      if (!this.text) return;
      const cutoff = Number(this.dataset.cutoff || 14);
      const minDays = Number(this.dataset.minDays || 3);
      const maxDays = Number(this.dataset.maxDays || 7);
      const current = this.parts(now);
      const sameDay = this.isBusinessDay(now) && current.hour < cutoff;
      const dispatch = sameDay ? now : this.nextBusinessDay(now);
      const minutesLeft = Math.max(0, Math.round((this.cutoffInstant(dispatch, cutoff).getTime() - now.getTime()) / 60000));
      const hours = Math.floor(minutesLeft / 60);
      const minutes = minutesLeft % 60;
      const time = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
      const dayLabel = `${this.fmtDay(dispatch)} ${this.fmtMonth(dispatch)}`;
      let lead;
      if (sameDay) lead = (this.dataset.before || '').replace('__TIME__', time);
      else if (this.dataset.next) lead = this.dataset.next.replace('__TIME__', time).replace('__DAY__', dayLabel);
      else lead = (this.dataset.after || '').replace('__DAY__', dayLabel);
      const earliest = this.addBusinessDays(dispatch, minDays);
      const latest = this.addBusinessDays(dispatch, maxDays);
      const sameMonth = this.fmtMonth(earliest) === this.fmtMonth(latest);
      const range = sameMonth
        ? `${this.fmtDay(earliest)} – ${this.fmtDay(latest)} ${this.fmtMonth(latest)}`
        : `${this.fmtDay(earliest)} ${this.fmtMonth(earliest)} – ${this.fmtDay(latest)} ${this.fmtMonth(latest)}`;
      const estimate = (this.dataset.estimate || '').replace('__RANGE__', range);
      this.text.innerHTML = estimate ? `${lead} ${estimate}` : lead;
      if (this.dataset.timeline) {
        const day = (d) => `${this.fmtDay(d)} ${this.fmtMonth(d)}`;
        const dispatchEl = this.querySelector('[data-tl-dispatch]');
        const deliveryEl = this.querySelector('[data-tl-delivery]');
        if (dispatchEl) dispatchEl.textContent = dispatch === now ? `${dispatchEl.dataset.today || 'Today'}, ${day(dispatch)}` : day(dispatch);
        if (deliveryEl) deliveryEl.textContent = range;
      }
      this.hidden = false;
    }
  }
  customElements.define('gdb-cart-dispatch', GdbCartDispatch);

  /* ---------- Product page: swap on variant change ---------- */
  function swapOnVariantChange(element, id) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return null;
    return subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const html = event && event.data && event.data.html;
      if (!html || event.data.sectionId !== element.dataset.sectionId) return;
      const fresh = html.getElementById(id);
      if (!fresh) return;
      element.innerHTML = fresh.innerHTML;
      element.hidden = fresh.hidden;
      if (typeof element.afterSwap === 'function') element.afterSwap();
    });
  }

  class GdbTierSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const pill = event.target.closest('[data-qty]');
        if (pill) this.select(Number(pill.dataset.qty));
      });
      this.input = document.getElementById(`Quantity-${this.dataset.sectionId}`);
      if (this.input) {
        this.input.addEventListener('change', () => this.reflect());
        this.reflect();
      }
      this.unsubscribe = swapOnVariantChange(this, this.id);
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    afterSwap() {
      this.reflect();
    }

    select(qty) {
      if (!this.input) return;
      const min = Number(this.input.min || 1) || 1;
      const max = this.input.max ? Number(this.input.max) : Infinity;
      const value = Math.min(Math.max(qty, min), max);
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.reflect();
    }

    reflect() {
      const value = this.input ? Number(this.input.value) : 1;
      this.querySelectorAll('[data-qty]').forEach((pill) => {
        pill.setAttribute('aria-pressed', Number(pill.dataset.qty) === value ? 'true' : 'false');
      });
    }
  }
  customElements.define('gdb-tier-selector', GdbTierSelector);

  class GdbLowStock extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = swapOnVariantChange(this, this.id);
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
  }
  customElements.define('gdb-low-stock', GdbLowStock);

  /* ---------- Product page: copy the offer code ---------- */
  class GdbCopyCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-copy]');
      this.label = this.querySelector('[data-copy-label]');
      if (!this.button) return;
      this.original = this.label ? this.label.textContent : '';
      this.button.addEventListener('click', () => this.copy());
    }

    async copy() {
      const code = this.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('input');
        input.value = code;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      if (this.label) {
        this.label.textContent = this.dataset.copied || 'Copied';
        this.button.classList.add('is-copied');
        setTimeout(() => {
          this.label.textContent = this.original;
          this.button.classList.remove('is-copied');
        }, 2000);
      }
    }
  }
  customElements.define('gdb-copy-code', GdbCopyCode);

  /* ---------- Free gift: keep exactly one $0 gift line in the cart when eligible ---------- */
  const gift = window.gdbGift;
  const giftIds = gift && gift.variants ? gift.variants.map((v) => Number(v.id)) : [];
  let giftBusy = false;
  let giftWanted = null;
  let giftFailedAt = null;
  const isGift = (item) => giftIds.includes(Number(item.variant_id)) || (item.properties && item.properties._gdb_gift);

  function preferredGift() {
    let stored = null;
    try {
      stored = Number(localStorage.getItem('gdbGiftVariant'));
    } catch (error) {
      stored = null;
    }
    return giftIds.includes(stored) ? stored : giftIds[0];
  }

  function rememberGift(variantId) {
    try {
      localStorage.setItem('gdbGiftVariant', String(variantId));
    } catch (error) {
      /* private mode */
    }
  }

  async function ensureGift(cart) {
    if (!gift || giftBusy || !giftIds.length) return;
    const giftLines = cart.items.filter(isGift);
    const others = cart.items.filter((item) => !isGift(item) && !item.gift_card);
    const orderOff = (cart.cart_level_discount_applications || []).reduce((sum, app) => sum + app.total_allocated_amount, 0);
    const subtotal = Math.max(0, others.reduce((sum, item) => sum + item.final_line_price, 0) - orderOff);
    const eligible = others.length > 0 && subtotal >= Number(gift.threshold || 0) && subtotal !== giftFailedAt;
    const paidGift = giftLines.find((item) => item.final_line_price > 0);
    let result = null;
    giftBusy = true;
    try {
      if (paidGift) {
        // Gift is not $0 (price changed?) — never charge for it.
        giftFailedAt = subtotal;
        result = await postCart(routes.cart_change_url, { id: paidGift.key, quantity: 0 });
      } else if (!eligible && giftLines.length) {
        for (const line of giftLines) result = await postCart(routes.cart_change_url, { id: line.key, quantity: 0 });
      } else if (eligible && giftLines.length === 0) {
        result = await postCart(routes.cart_add_url, {
          items: [{ id: preferredGift(), quantity: 1, properties: { _gdb_gift: '1' } }],
        });
      } else if (giftLines.length > 1) {
        for (const line of giftLines.slice(1)) result = await postCart(routes.cart_change_url, { id: line.key, quantity: 0 });
      } else if (giftLines.length && giftLines[0].quantity !== 1) {
        result = await postCart(routes.cart_change_url, { id: giftLines[0].key, quantity: 1 });
      }
    } catch (error) {
      result = null;
    } finally {
      giftBusy = false;
    }
    if (giftWanted) applyGiftWanted();
    if (!result) return;
    if (result.sections) renderSections(result.sections);
    if (document.querySelector('cart-items')) window.location.reload();
  }

  async function checkGift() {
    if (!gift) return;
    try {
      const cart = await (await fetch(`${routes.cart_url}.js`)).json();
      await ensureGift(cart);
    } catch (error) {
      /* leave the cart as it is */
    }
  }

  /* Swap the chosen mask: paint the row straight away, then ONE /cart/update.js call (old mask -> 0, new mask -> 1). */
  function paintGiftRow(select) {
    const option = select.options[select.selectedIndex];
    const row = select.closest('.cart-item');
    if (!option || !row) return;
    const image = row.querySelector('.cart-item__image');
    if (image && option.dataset.img) image.src = option.dataset.img;
    const value = row.querySelector('.product-option dd');
    if (value) value.textContent = option.text;
  }
  async function applyGiftWanted() {
    if (giftBusy || !giftWanted) return;
    giftBusy = true;
    let result = null;
    try {
      while (giftWanted) {
        const next = giftWanted;
        giftWanted = null;
        const updates = {};
        giftIds.forEach((id) => {
          updates[id] = String(id) === next ? 1 : 0;
        });
        result = await postCart(routes.cart_update_url, { updates });
      }
    } catch (error) {
      result = null;
    } finally {
      giftBusy = false;
      giftWanted = null;
    }
    if (result && result.sections) renderSections(result.sections);
  }
  function switchGift(select) {
    paintGiftRow(select);
    giftWanted = String(select.value);
    applyGiftWanted();
  }

  let giftSubmitting = false;

  if (gift) {
    // Capture phase + stopPropagation: Dawn's cart-items listens for `change` and would treat the mask
    // dropdown as a quantity field ("You can only add this item in increments of undefined").
    document.addEventListener(
      'change',
      (event) => {
        const real = event.target.closest('[data-gift-line]');
        if (real) {
          event.stopPropagation();
          rememberGift(real.value);
          switchGift(real);
          return;
        }
        const virtual = event.target.closest('[data-gift-virtual-select]');
        if (virtual) {
          event.stopPropagation();
          rememberGift(virtual.value);
          paintGiftRow(virtual);
        }
      },
      true
    );

    // Check out clicked while the gift line is still the instant (virtual) one: create the real line first.
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('button[name="checkout"]');
        if (!button || giftSubmitting || !document.querySelector('[data-gift-virtual]')) return;
        event.preventDefault();
        giftSubmitting = true;
        checkGift()
          .catch(() => {})
          .then(() => {
            const fresh = document.querySelector('#CartDrawer button[name="checkout"]') || button;
            if (fresh.form && typeof fresh.form.requestSubmit === 'function') fresh.form.requestSubmit(fresh);
            else window.location.href = '/checkout';
          });
      },
      true
    );

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => checkGift());
    checkGift();
  }
})();
